@if ({ state: addressState$ | async }; as states) {
  <span class="lens-icon">
    <img src="/assets/images/svg/search.svg" />
  </span>
  <bp-input
    [model]="model"
    [placeholder]="placeholder"
    [displayLogo]="true"
    [label]="label"
    [type]="'text'"
    [field]="'street'"
    [secondLine]="['zipcode', 'city', 'country_name']"
    (focusout)="handleFocusOut(states?.state)"
    (onInputModified)="updateHasInput($event)"
    (inputGroupEvent)="inputGroup = $event">
  </bp-input>
  <div class="top-label">
    @if (bottomLabel && !profile.street) {
      <label class="bottom-label text-light">
        {{ bottomLabel }}
      </label>
    }
  </div>
  <!-- Loading results -->
  <ng-container>
    @if (!states.state.searchFinished && hasInput) {
      <div class="loading-container">
        <div class="loading-spinner">
          <loading-spinner></loading-spinner>
        </div>
        <span>{{ "autofill_address_searching" | translate }}</span>
      </div>
    } @else {
      <!-- Show predictions -->
      @if (predictions.length > 0 && showSuggestions) {
        <div
          class="flex flex-col flag-on-maps-result-container width-address-search"
          >
          @for (result of predictions; track result) {
            <div
              class="flag-on-maps-result-item"
              (mousedown)="searchResultClick(result, $event, states?.state)">
              <div class="flex flex-col text">
                <span
                  [baseText]="result.structured_formatting.main_text"
                  [appHighlight]="inputGroup.nativeElement.value"
                  class="main_text"
                  >{{ result.structured_formatting.main_text }}
                </span>
                <span class="secondary_text"
                  >{{ result.structured_formatting.secondary_text }}
                </span>
              </div>
            </div>
          }
        </div>
      }
      <!-- No results -->
      @if (predictions.length === 0 && hasInput && showSuggestions) {
        <div
          class="address-no-suggestion-box"
          >
          <div class="address-no-suggestion-box-item flex flex-col">
            <span class="no-found-main">{{ "autofill_address_not_found_title" | translate }}</span>
            <span class="no-found-other">{{ "autofill_address_not_found_text" | translate }}</span>
          </div>
          <!-- Add manually in no results -->
          @if (showManualAddressEdit) {
            <div class="address-no-suggestion-box-item">
              <button
                (mousedown)="onManualAddressClick()"
                (keydown.enter)="onManualAddressClick()"
                [tabIndex]="0"
                class="manual-address">
                {{ "autofill_address_to_manual" | translate }}
              </button>
            </div>
          }
        </div>
      }
      <!-- Enter Street Number Advice -->
      @if (!states.state.hasStreetNumber && states.state.searchFinished && inputGroup.nativeElement.value.length > 0) {
        <div
          class="complete-street-container"
          >
          <span class="complete-street-number">{{ "autofill_address_to_complete" | translate }}</span>
        </div>
      }
    }
  </ng-container>
}
